import { render, staticRenderFns } from "./NewsFeed.vue?vue&type=template&id=e2513910"
import script from "./NewsFeed.vue?vue&type=script&lang=js"
export * from "./NewsFeed.vue?vue&type=script&lang=js"
import style0 from "./NewsFeed.vue?vue&type=style&index=0&id=e2513910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports